import React from 'react';
import Appointment from '../Appointment/Appointment';
import Banner from '../Banner/Banner';
import Doctors from '../Doctors/Doctors';
import Services from '../Services/Services';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <Services></Services>
            <Appointment></Appointment>
            <Doctors></Doctors>
        </div>
    );
};

export default Home;





// 💊🧬🩺📎☄
